var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRomantic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5014 2.40639C14.0462 0.121645 17.9787 0.197478 20.4302 2.6534C22.8807 5.11039 22.9653 9.0234 20.6859 11.5757L11.4992 20.7754L2.31475 11.5757C0.0354154 9.0234 0.120999 5.1039 2.57042 2.6534C5.02417 0.200728 8.94908 0.118395 11.5014 2.40639Z",
    fill: "currentFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRomantic);
export default __webpack_public_path__ + "static/media/romantic.51b0b04e3223cdf0a4d8a7d69582187e.svg";
export { ForwardRef as ReactComponent };